import React, { useEffect, useState } from "react";

import Service1 from "../../components/home-services/servicedetail/Service1";

import ReactService1 from "!!raw-loader!../../components/home-services/servicedetail/Service1";

import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { darcula } from "react-syntax-highlighter/dist/esm/styles/prism";
import PreviewCodeSection from "../../subcomponent/PreviewCode/PreviceCodeSection";

import pretty from "pretty";

const ComponentData = [
  {
    id: 1,
    component: Service1,
    rawString_React: ReactService1,
  },
];

const Services = () => {
  return (
    <>
      {ComponentData.map((obj) => {
        return (
          <PreviewCodeSection
            key={obj?.id}
            Component={obj?.component}
            rawString_React={obj?.rawString_React}
          />
        );
      })}
    </>
  );
};

export default Services;
